




import echarts, { EChartOption } from 'echarts'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import ResizeMixin from './mixins/resize'
export interface ILineChartData {
  actualData: any[]
}
@Component({
  name: 'LineChart',
})
export default class extends mixins(ResizeMixin) {
  @Prop({ required: true }) private chartTitle!: string
  @Prop({ default: 'chart' }) private className!: string
  @Prop({ default: '100%' }) private width!: string
  @Prop({ default: '350px' }) private height!: string
  @Prop({ required: true }) private dataCharts
  @Prop({}) public hasSearch: boolean | undefined

  @Watch('dataChart', { deep: true })
  private onChartDataChange(value: ILineChartData) {
    this.setOptions(value)
  }
  // tslint:disable-next-line:member-ordering
  public mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  }
  // tslint:disable-next-line:member-ordering
  public beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }
  private initChart() {
    this.chart = echarts.init(this.$el as HTMLDivElement, 'macarons')
    this.setOptions(this.dataCharts)
  }

  private get userData() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push(item.value)
    }
    return array
  }

  private get getDay() {
    const array: any = []
    for (const item of this.dataCharts) {
      array.push(item.period)
    }
    return array
  }
  private setOptions(dataChart: ILineChartData) {
    if (this.chart) {
      this.chart.setOption({
        xAxis: {
          data: this.getDay,
          boundaryGap: false,
          axisTick: {
            show: false,
          },
        },
        grid: {
          left: 10,
          right: 50,
          bottom: 20,
          top: 30,
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
          },
          padding: 8,
        },
        yAxis: {
          axisTick: {
            show: false,
          },
        },
        legend: {
          data: [this.chartTitle],
        },

        series: [
          {
            name: this.chartTitle,
            smooth: true,
            type: 'line',
            itemStyle: {
              color: 'red',
              lineStyle: {
                color: 'red',
                width: 2,
              },
              areaStyle: {
                color: 'blue',
              },
            },
            data: this.userData,
            animationDuration: 8000,
            animationEasing: 'quadraticOut',
          },
        ],
      } as EChartOption<EChartOption.SeriesLine>)
    }
  }
}
